import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, Subject } from "rxjs";

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

interface IGetGuestDetail {
  page: number;
  page_size: number;
  client_id: number;
}

interface IDeleteGuest {
  client_id: number;
  reservation_code: string;
}

interface IGetSimilarGuest {
  client_id: number;
}

interface IMergeGuests {
  client_id_a: number;
  client_id_b: number;
}

interface IGetGuestList {
  page: number;
  page_size: number;
  reservation_code: string;
}

interface IAddClientToReservation {
  client_id: number;
  reservation_code: string;
}

interface IDeleteClient {
  id: number;
}

const GET_GUEST_DETAIL_API = "/api/client/list";
const GET_CLIENT_AREAS_API = "/api/client/areas";
const DELETE_CLIENT_API = "/api/reservation/reservation_remove_client";
const GET_SIMILAR_CLIENTS_API = "/api/client/similar_clients";
const MERGE_GUESTS_API = "/api/client/merge_clients";
const GET_GUEST_LIST_API = "/api/client/list";
const ADD_GUEST_TO_RESERVATION_API = "/api/reservation/reservation_add_client";
const DELETE_GUEST_API = "/api/client/delete";

@Injectable({
  providedIn: "root",
})
export class HouseOrderGuestService {
  orderGuestListRefreshRaw$ = new Subject<boolean>();

  constructor(private http: HttpClient) {}

  updateOrderGuestListRefresh(message) {
    this.orderGuestListRefreshRaw$.next(message);
  }

  /** 获取房客详情 */
  getGuestDetail(params: IGetGuestDetail) {
    const query = new HttpParams()
      .append("page", `${params.page}`)
      .append("page_size", `${params.page_size}`)
      .append("client_id", `${params.client_id}`);
    return this.http.get(GET_GUEST_DETAIL_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 获取国家列表 */
  getCountryList() {
    return this.http.get(GET_CLIENT_AREAS_API) as Observable<IHttpResponse>;
  }

  /** 移除房客 */
  deleteGuest(params: IDeleteGuest) {
    return this.http.post(DELETE_CLIENT_API, params) as Observable<
      IHttpResponse
    >;
  }

  /** 相似房客列表 */
  getSimilarClients(params: IGetSimilarGuest) {
    const query = new HttpParams().append("client_id", `${params.client_id}`);
    return this.http.get(GET_SIMILAR_CLIENTS_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 合并相似房客 */
  mergeSimilarGuest(params: IMergeGuests) {
    return this.http.post(MERGE_GUESTS_API, params) as Observable<
      IHttpResponse
    >;
  }

  /** 房客列表 */
  getGuestList(params: IGetGuestList) {
    const query = new HttpParams()
      .append("page", `${params.page}`)
      .append("page_size", `${params.page_size}`)
      .append("reservation_code", `${params.reservation_code}`);
    return this.http.get(GET_GUEST_LIST_API, { params: query }) as Observable<
      IHttpResponse
    >;
  }

  /** 为入住单添加新房客 */
  addGuestToReservation(params: IAddClientToReservation) {
    return this.http.post(ADD_GUEST_TO_RESERVATION_API, params) as Observable<
      IHttpResponse
    >;
  }

  /** 删除房客 */
  deleteClient(params: IDeleteClient) {
    return this.http.post(DELETE_GUEST_API, params) as Observable<
      IHttpResponse
    >;
  }
}
